<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      :custom-on-row-click="goto"
      :model="model"
      :use-add-action="false"
      :use-edit-action="false"
      entity-name="purpose"
    >
      <template #primaryButton>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="newAdd"
        >
          <div
            class="d-flex align-center"
          >
            <v-icon
              left
            >
              mdi-plus-circle-outline
            </v-icon>
            <template>
              <div
                class="text-truncate"
                style="max-width: 80px !important;"
              >
                {{ $t('purpose') }}
              </div>
            </template>
          </div>
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="cashAccountDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center">
          <div class="text-h3 font-weight-bold">
            {{ $t('Details') }}
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="cashAccountDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="mt-4">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <div class="text-overline">
              {{ $t('name') }}
            </div>
            <v-text-field
              v-model="editItem.usageName"
              :rules="rules"
              dense
              hide-details
              outlined
            />
            <div class="text-overline">
              {{ $t('inOrOut') }}
            </div>
            <v-select
              v-model="editItem.lrMark"
              :items="lrType"
              :rules="rules"
              dense
              hide-details
              item-text="label"
              item-value="value"
              outlined
            />
            <div class="text-overline">
              {{ $t('Typ') }}
            </div>
            <v-select
              v-model="editItem.typeCode"
              :items="editItem.lrMark === '1' ? lr1List : lr2List"
              :rules="rules"
              dense
              hide-details
              item-text="label"
              item-value="value"
              outlined
            />
            <div
              v-for="(item,index) in latestTaxRateNames"
              :key="index"
            >
              <div class="text-overline no-uppercase">
                DATEV Konto {{ item.rateValue | percent }} ({{ $t('option_info') }})
              </div>
              <v-text-field
                v-model="item.account"
                dense
                hide-details
                outlined
              />
            </div>
          </v-form>
        </div>
        <v-btn
          class="primary mt-4"
          width="100%"
          @click="saveAccount"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import cashAccount from '@/model/dataLayer/api/cashbook/cashAccount'
import i18n from '@/i18n'
import { getLatestTaxRateNames } from '@/model/dataLayer/api/cashbook/cashbook'

export default {
  name: 'CashBookCashAccount',
  components: {
    IkDataTable
  },
  data: function () {
    return {
      latestTaxRateNames: [],
      rules: [
        v => !!v || i18n.t('ItemRequired')
      ],
      valid: true,
      lr1List: [{ label: i18n.t('cashDeposit'), value: 'cashDeposit' },
        { label: i18n.t('moneyTransit'), value: 'moneyTransit' },
        { label: i18n.t('inPayment'), value: 'inPayment' },
        { label: i18n.t('differenceTargetActual'), value: 'differenceTargetActual' }],
      lr2List: [{ label: i18n.t('cashWithdraw'), value: 'cashWithdraw' },
        { label: i18n.t('moneyTransit'), value: 'moneyTransit' },
        { label: i18n.t('outPayment'), value: 'outPayment' },
        { label: i18n.t('differenceTargetActual'), value: 'differenceTargetActual' },
        { label: i18n.t('paymentOfWages'), value: 'paymentOfWages' }],
      lrType: [{ label: i18n.t('deposit'), value: '1' },
        { label: i18n.t('withdraw'), value: '2' }],
      defaultItem: {
        usageName: '',
        lrMark: '',
        typeCode: '',
        accountA: '',
        accountB: '',
        accountC: ''
      },
      editMode: false,
      editItem: {},
      cashAccountDialog: false,
      model: cashAccount
    }
  },
  methods: {
    newAdd () {
      this.$refs?.form?.resetValidation()
      this.editMode = false
      Object.assign(this.editItem, this.defaultItem)
      this.latestTaxRateNames.forEach(it => {
        it.account = ''
      })
      this.cashAccountDialog = true
    },
    goto (item) {
      this.editItem = item
      this.editMode = true
      this.latestTaxRateNames.forEach(it => {
        if (it.name === 'A') {
          it.account = this.editItem.accountA
        }
        if (it.name === 'B') {
          it.account = this.editItem.accountB
        }
        if (it.name === 'C') {
          it.account = this.editItem.accountC
        }
      })
      this.cashAccountDialog = true
    },
    async saveAccount () {
      if (this.$refs.form.validate()) {
        this.latestTaxRateNames.forEach(it => {
          if (it.name === 'A') {
            this.editItem.accountA = it.account
          }
          if (it.name === 'B') {
            this.editItem.accountB = it.account
          }
          if (it.name === 'C') {
            this.editItem.accountC = it.account
          }
        })
        if (this.editMode) {
          await cashAccount.edit(this.editItem)
        } else {
          await cashAccount.add(this.editItem)
        }
        await this.$refs.table.reload()
        this.cashAccountDialog = false
      }
    }
  },
  async mounted () {
    this.latestTaxRateNames = await getLatestTaxRateNames()
    console.log(this.latestTaxRateNames, 'latestTaxRateNames')
  }
}
</script>

<style scoped>
.no-uppercase {
  text-transform: none !important;  /* 取消大写样式 */
}
</style>
